







import { assetDataType } from '@/utilities/shared-report-helpers.js'
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Icon } from '@alpha/ink'

@Component({
  components: {
    Icon
  }
})
export default class SharedReportNavElement extends Vue {
  @Prop() item!: any
  @Prop() active!: any
  @Prop() summary!: any
  @Prop() prototypes!: any
  @Prop({ default: false }) editable!:boolean

  get itemClass ():string {
    var str = 'nav-' + this.item.type
    if (this.active) {
      str += ' active'
    }
    return str
  }

  get itemTitle ():string {
    var item = this.item
    var that = this
    switch (item.type) {
      case 'intro':
        return item.page.title
      case 'section':
        return item.page.section.title
      case 'question':
        return item.page.drop.payload.title
      case 'summary':
        return that.summary.questions + ' Test' + (that.summary.questions > 1 ? 's' : '') + ', ' + that.summary.people + ' User Impressions.'
      case 'prototypes':
        return that.prototypes + ' Test Assets.'
      default: // erorr case, actually
        console.error('Broken item in shared report, has no type.')
        return 'Error'
    }
  }

  get questionAssets ():any {
    var that = this
    if (this.item.type === 'question') {
      var assets = {
        Audio: {
          present: false,
          icon: 'mic_none'
        },
        Video: {
          present: false,
          icon: 'voice_chat'
        },
        Data: {
          present: false,
          icon: 'insert_chart'
        },
        Text: {
          present: false,
          icon: 'format_quote'
        }
      }
      Object.keys(this.item.page.assets).forEach(function (assetId:any) {
        var asset = that.item.page.assets[assetId]
        switch (assetDataType(asset)) {
          case 'Chart':
          case 'VizSlice':
          case 'Data':
            assets.Data.present = true
            break
          case 'Video':
            assets.Video.present = true
            break
          case 'Text':
            assets.Text.present = true
            break
          case 'Audio':
            assets.Audio.present = true
            break
        }
      })
      return assets
    } else {
      return false
    }
  }
}
